var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form-item",
    { attrs: { label: "提示文字" } },
    [
      _c("el-input", {
        attrs: {
          size: "small",
          placeholder: "请输入",
          maxlength: "50",
          "show-word-limit": "",
        },
        model: {
          value: _vm.value.placeholder,
          callback: function ($$v) {
            _vm.$set(_vm.value, "placeholder", $$v)
          },
          expression: "value.placeholder",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }